'use strict';

module.exports = {
  apiHost: 'https://developer-api.august.com',
};
